import React from 'react';
import { motion } from 'framer-motion';
import type { AccountRole } from '../../types';
interface OnboardingProgressProps {
  currentStep: number;
  totalSteps?: number;
  role: AccountRole;
}
export function OnboardingProgress({
  currentStep,
  totalSteps = 3,
  role
}: OnboardingProgressProps) {
  const getRoleColor = (isCompleted: boolean) => {
    if (role === 'learner') return isCompleted ? 'bg-orange-500' : 'bg-orange-200';
    if (role === 'parent') return isCompleted ? 'bg-emerald-500' : 'bg-emerald-200';
    if (role === 'teacher') return isCompleted ? 'bg-indigo-500' : 'bg-indigo-200';
    return isCompleted ? 'bg-slate-500' : 'bg-slate-200';
  };
  return <div className="flex justify-center gap-2 mb-6" role="progressbar" aria-valuemin={1} aria-valuemax={totalSteps} aria-valuenow={currentStep + 1} aria-label={`Stap ${currentStep + 1} van ${totalSteps}`} data-id="element-298">
      {Array.from({
      length: totalSteps
    }).map((_, i) => {
      const isActive = i === currentStep;
      const isCompleted = i <= currentStep;
      return <motion.div key={i} initial={false} animate={{
        width: isActive ? 24 : 8
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className={`h-2 rounded-full ${getRoleColor(isCompleted)}`} data-id="element-299" />;
    })}
    </div>;
}